// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"45105f6a","977":"af7ece4a"}[chunkId] + ".chunk.js";
};